/**
 * Pop-up montré au tuteur qui déborde sur sa séance suivante. La surface élève
 * (le bandeau d'attente) vit dans `tutorNoShow`.
 */

export { TutorOverrunDialog } from "./components/TutorOverrunDialog"
